import React, { useState } from 'react';
import { Paper, Tab, Tabs, Typography } from '@mui/material';

import DashboardContainer from '../../components/admin/DashboardContainer';

import RewardForm from '../../components/admin/rewards/RewardForm';
import RewardsList from '../../components/admin/rewards/RewardsList';
import RewardsClaimsList from '../../components/admin/rewards/RewardsClaimsList';
import { SelectCompany } from '../../components/admin/SelectCompany';

export default function Rewards() {
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    // const company = useCompany();

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <DashboardContainer title={'Mensajes'}>
            <Paper sx={{ p: 4 }}>
                <SelectCompany selectedCompanyId={selectedCompanyId} setSelectedCompanyId={setSelectedCompanyId} />
                <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth">
                    <Tab label="Recompensas" />
                    <Tab label="Canjeos" />
                </Tabs>
                {activeTab === 0 && (
                    <div>
                        <Typography variant="h6" component="div" mt={2}>
                            Recompensas
                        </Typography>
                        <RewardsList companyId={selectedCompanyId} canEdit={true} />
                        <RewardForm companyId={selectedCompanyId} />
                    </div>
                )}
                {activeTab === 1 && (
                    <div>
                        <Typography variant="h6" component="div" mt={2}>
                            Canjeos
                        </Typography>
                        <RewardsClaimsList companyId={selectedCompanyId} />
                    </div>
                )}
            </Paper>
        </DashboardContainer>
    );
}
